import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  savedVariables: [],
  settings: {
    showSelfTests: true,
    showAlarms: true,
    showStandBy: true
  }
};

export const preferenceSlice = createSlice({
  name: "preference",
  initialState,
  reducers: {
    saveVariables: (state, action) => {
      state.savedVariables = [...action.payload];
    },
    saveGraphSettings: (state, action) => {
      state.settings = { ...action.payload };
    }
  }
});

export const { saveVariables, saveGraphSettings } = preferenceSlice.actions;
export default preferenceSlice.reducer;
